import OfacMonitoringIndex from '@/views/OfacMonitoring/OfacMonitoringIndex.vue';
import OfacReportsIndex from '@/views/OfacMonitoring/OfacReports/OfacReportsIndex.vue';
import OfacMatchesIndex from '@/views/OfacMonitoring/OfacMatches/OfacMatchesIndex.vue';
import OfacEmailNotificationSettingsIndex from '@/views/OfacMonitoring/OfacEmailNotificationSettings/OfacEmailNotificationSettingsIndex.vue';
import ComplianceIndex from '@/views/Compliance/ComplianceIndex.vue';
import ComplianceLeadIndex from '@/views/Compliance/Lead/ComplianceLeadIndex.vue';
import ComplianceNoaaIndex from '@/views/Compliance/NOAA/ComplianceNoaaIndex.vue';
import FincenIndex from '@/views/Fincen/FincenIndex.vue';
import FincenPersonsIndex from '@/views/Fincen/FincenPersons/FincenPersonsIndex.vue';
import FincenFilesIndex from '@/views/Fincen/FincenFiles/FincenFilesIndex.vue';
import FincenBatchesIndex from '@/views/Fincen/FincenBatches/FincenBatchesIndex.vue';

export default [
  {
    path: 'compliance',
    name: 'compliance',
    component: ComplianceIndex,
    meta: {
      title: 'Compliance',
      permission: 'view compliance',
    },
    children: [
      {
        path: 'compliance-lead',
        name: 'compliance-lead',
        component: ComplianceLeadIndex,
        meta: {
          title: 'Lead Compliance',
          permission: 'view compliance::lead',
        },
      },
      {
        path: 'compliance-noaa',
        name: 'compliance-noaa',
        component: ComplianceNoaaIndex,
        meta: {
          title: 'Compliance Noaa',
          permission: 'view compliance::noaa',
        },
      },
      {
        path: 'ofac-monitoring',
        name: 'ofac-monitoring',
        component: OfacMonitoringIndex,
        meta: {
          title: 'OFAC Monitoring',
          permission: 'view ofac',
        },
        children: [
          {
            path: 'matches',
            name: 'ofac-matches',
            component: OfacMatchesIndex,
            meta: {
              title: 'OFAC Review Matches',
              permission: 'view ofac::matches-list',
            },
          },
          {
            path: 'reports',
            name: 'ofac-reports',
            component: OfacReportsIndex,
            meta: {
              title: 'OFAC Report List',
              permission: 'view ofac::report-list',
            },
          },
          {
            path: 'email-notifications-settings',
            name: 'email-notifications-settings',
            component: OfacEmailNotificationSettingsIndex,
            meta: {
              title: 'OFAC Email Notifications',
              permission: 'view ofac::email-notification-settings',
            },
          },
        ],
      },
      {
        path: 'fincen',
        name: 'fincen',
        component: FincenIndex,
        meta: {
          title: 'FinCen',
          permission: 'view fincen',
        },
        children: [
          {
            path: 'files',
            name: 'fincen-files',
            component: FincenFilesIndex,
            meta: {
              title: 'FinCen File List',
              permission: 'view fincen::files',
            },
          },
          {
            path: 'batches',
            name: 'fincen-batches',
            component: FincenBatchesIndex,
            meta: {
              title: 'FinCen Batch List',
              permission: 'view fincen::batches',
            },
          },
          {
            path: 'persons',
            name: 'fincen-persons',
            component: FincenPersonsIndex,
            meta: {
              title: 'FinCen Persons List',
              permission: 'view fincen::persons',
            },
          },
        ],
      },
    ],
  },
];
